import { makeAutoObservable, runInAction } from 'mobx';
import { FedexV2WizardStep } from './fedex-v2-credentials.types';
import { FedexV2ChildCredentials } from './fedex-v2-registration-api';

class FedexV2RegistrationWizardStore {
    private _step: FedexV2WizardStep = 'eula';
    private _isLoading = false;
    private _error = '';
    private _isComplete = false;
    private _closed = false;
    private _childCredentials: FedexV2ChildCredentials | null = null;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    get step() {
        return this._step;
    }

    get isLoading() {
        return this._isLoading;
    }

    get error() {
        return this._error;
    }

    get isComplete() {
        return this._isComplete;
    }

    get isClosed() {
        return this._closed;
    }

    get childCredentials() {
        return this._childCredentials;
    }

    abandon() {
        if (this._closed) {
            return;
        }
        this._closed = true;
        this._isLoading = false;
    }

    markClosed() {
        this._closed = true;
    }

    goToAddress() {
        this._step = 'address';
    }

    goToMfaSelect() {
        this._step = 'mfa-select';
    }

    goToMfaInput() {
        this._step = 'mfa-input';
    }

    complete(credentials: FedexV2ChildCredentials) {
        this._childCredentials = credentials;
        this._step = 'complete';
        this._isComplete = true;
    }

    async runAsync(task: () => Promise<void>) {
        if (this._closed) {
            return;
        }

        this._isLoading = true;
        this._error = '';

        try {
            await task();
        } catch (error: unknown) {
            runInAction(() => {
                if (!this._closed) {
                    this._error = this.getErrorMessage(error);
                }
            });
        } finally {
            runInAction(() => {
                if (!this._closed) {
                    this._isLoading = false;
                }
            });
        }
    }

    private getErrorMessage(error: unknown) {
        const apiError = error as { response?: { data?: { message?: string } }; message?: string };
        return apiError?.response?.data?.message ?? apiError?.message ?? '';
    }
}

export default FedexV2RegistrationWizardStore;
